import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		redirect: {
			name: "home",
		},
	},
	{
		path: "/homeview",
		name: "home",
		component: HomeView,
	},
	{
		path: "/test",
		name: "test",
		component: () => import("../views/TestView.vue"),
	},
	{
		path: "/good",
		name: "good",
		component: () => import("../views/GoodsDetail.vue"),
	},
	{
		path: "/redpacket",
		name: "redpacket",
		component: () => import("../views/RedPacket.vue"),
	},
	{
		path: "/reddetail",
		name: "reddetail",
		component: () => import("../views/RedDetails.vue"),
	},
	{
		path: "/myred",
		name: "myred",
		component: () => import("../views/MyRed.vue"),
	},
	// {
	// 	path: "/signform",
	// 	name: "signform",
	// 	component: () => import("../views/SignForm.vue"),
	// },
];

const router = new VueRouter({
	routes,
});
router.beforeEach((to, from, next) => {
	// Guard...
	next();
});

export default router;
